import { render } from "./TamanhosFiltro.vue?vue&type=template&id=15498f76"
import script from "./TamanhosFiltro.vue?vue&type=script&lang=js"
export * from "./TamanhosFiltro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__